import { ActivityLog } from '@models';

export interface FoundationActivityLogResult {
  claActivityLogs: ActivityLog[];
}
